import React from "react";
import { useTranslation } from "react-i18next";
import "./OssSituationModal.css";

export default function OssSituationModal({
  open = false,
  onClose,
  onHasProperty,
  onStillLooking,
}) {
  const { t } = useTranslation("homebuyer-oss-modal");

  const [isClosing, setIsClosing] = React.useState(false);

  React.useEffect(() => {
    if (open) setIsClosing(false);
  }, [open]);

  if (!open) return null;

  function closeWithAnimation() {
    setIsClosing(true);

    window.setTimeout(() => {
      onClose?.();

      setIsClosing(false);
    }, 180);
  }

  if (!open) return null;

  return (
    <div
      className={`oss-situation-modal-backdrop ${
        isClosing ? "is-closing" : ""
      }`}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) closeWithAnimation();
      }}
    >
      <div className="oss-situation-modal" onClick={(e) => e.stopPropagation()}>
        <div className="oss-situation-modal__heading">
          <div className="oss-situation-modal__icon">?</div>

          <h3 className="oss-situation-modal__title">
            {t("ossModal.title", "Choose your situation")}
          </h3>
        </div>

        <p className="oss-situation-modal__text">
          {t(
            "ossModal.description",
            "Before connecting you with a One-Stop Shop, tell us whether you already have found a property in mind or if you are still searching.",
          )}
        </p>

        <div className="oss-situation-modal__choices">
          <button
            type="button"
            className="oss-situation-modal__choice"
            onClick={onHasProperty}
          >
            <span className="oss-situation-modal__choice-badge">A</span>
            <span className="oss-situation-modal__choice-content">
              <strong>
                {t("ossModal.hasPropertyTitle", "I have found a property")}
              </strong>
              <small>
                {t(
                  "ossModal.hasPropertyDescription",
                  "You’ve found a home and want OSS support for renovation planning and next steps.",
                )}
              </small>
            </span>
          </button>

          <button
            type="button"
            className="oss-situation-modal__choice"
            onClick={onStillLooking}
          >
            <span className="oss-situation-modal__choice-badge">B</span>
            <span className="oss-situation-modal__choice-content">
              <strong>
                {t(
                  "ossModal.searchingTitle",
                  "I’m still looking for a property",
                )}
              </strong>
              <small>
                {t(
                  "ossModal.searchingDescription",
                  "You have not selected a property yet and want OSS guidance before moving forward.",
                )}
              </small>
            </span>
          </button>
        </div>

        <button
          type="button"
          className="oss-situation-modal__cancel"
          onClick={closeWithAnimation}
        >
          {t("common.cancel", "Cancel")}
        </button>
      </div>
    </div>
  );
}
